/**
 * InputPassword Component - Component Definition
 * ==============================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { InputPasswordController } from './controller';
import { INPUT_PASSWORD_TEMPLATE } from './template';
import { SIZES, BASE_CLASSES, ICONS, DEFAULTS, InputPasswordSize } from './constants';

export interface IInputPasswordComponentBindings {
  label?: string;
  placeholder?: string;
  helpMessage?: string;
  error?: boolean;
  disabled?: boolean;
  size?: InputPasswordSize;
  inputId?: string;
  autocomplete?: string;
  onChange?: (args: { value: string }) => void;
}

export const inputPasswordComponentDefinition: IComponentOptions = {
  template: INPUT_PASSWORD_TEMPLATE,
  controller: InputPasswordController,
  require: { ngModelCtrl: '?ngModel' },
  // Slots nombrados: <ec-label>/<ec-help> dentro del componente.
  transclude: { labelSlot: '?ecLabel', helpSlot: '?ecHelp' },
  bindings: {
    label: '@',
    placeholder: '@',
    helpMessage: '@',
    error: '<',
    disabled: '<',
    size: '@',
    inputId: '@',
    autocomplete: '@',
    onChange: '&?'
  }
};

export const MODULE_NAME = 'ec.inputPassword';

const inputPasswordModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecInputPassword', inputPasswordComponentDefinition);

export { InputPasswordController, INPUT_PASSWORD_TEMPLATE, SIZES, BASE_CLASSES, ICONS, DEFAULTS };
export type { InputPasswordSize } from './constants';
export default inputPasswordModule;
